// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ca27526b","409":"0368553a","411":"9d4652a5","422":"1cddb59b","560":"9ff5916f","621":"6f51bd2e","633":"63874224","724":"98e12812","775":"da315d8a","787":"e2c716d7","830":"9d7c34a2","863":"96c35097","930":"8b372fea","939":"4685d280","985":"53312100"}[chunkId] + ".chunk.js";
};